/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-01 15:37:51
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-02-17 13:49:15
 */

const patient = [
    {
        path: '/patient/service/:id/:doctorId/:tenantId',
        name: 'patientService',
        component: () => import('../views/patient/service.vue'),
    },
    {
        path: '/patient/report/:id',
        name: 'patientReport',
        component: () => import('../views/patient/report.vue'),
    },
    {
        path: '/patient/report/:id/:projectId',
        name: 'patientReport',
        component: () => import('../views/patient/report.vue'),
    },
    {
        path: '/patient/report/success/:id',
        name: 'patientReportSuccess',
        component: () => import('../views/patient/model-report-success.vue'),
    },
    {
        path: '/patient/inquiry',
        name: 'patientInquiry',
        component: () => import('../views/patient/inquiry.vue'),
    },
    {
        path: '/patient/list',
        name: 'patientlist',
        component: () => import('../views/patient/list.vue'),
    },
    {
        path: '/patient/add/:id?/:consultationId?',
        name: 'patientAdd',
        component: () => import('../views/patient/add.vue'),
    },
    {
        path: '/patient/detail',
        name: 'patientdetail',
        component: () => import('../views/patient/detail.vue'),
    },
    {
        path: '/case/list',
        name: 'caseList',
        component: () => import('../views/patient/caseList.vue'),
    },
]
export default patient



// WEBPACK FOOTER //
// ./src/router/patient.js